<template>
    <section class="landing landingbb purchase-sale purchase-sale-info">
        <div class="container">
                <div class="landing-content subpage-heading-center">
                    <span class="heading-title">{{ $t('SellAutoInt.header') }} </span>
                    <hr>
                    <span class="paragraph">{{ $t('SellAutoInt.description') }}</span>
                    <span class="paragraph">{{ $t('SellAutoInt.inserat') }}</span>

                    <img src="https://auto-moto-sales.web.app/images/9.svg">

                    <span class="paragraph">{{ $t('SellAutoInt.top') }}</span>

                    <img src="https://auto-moto-sales.web.app/images/3.png">
                    <img src="https://auto-moto-sales.web.app/images/8.jpg">
                    <img src="https://auto-moto-sales.web.app/images/1.png">

                    <span class="paragraph">{{ $t('SellAutoInt.prioritaet') }}</span>

                    <img src="https://auto-moto-sales.web.app/images/4.png">

                    <span class="paragraph">{{ $t('SellAutoInt.kosten') }}</span>
                    <span class="paragraph">{{ $t('SellAutoInt.internet') }}</span>
                    <router-link :to="localizedPath('autoSale')" class="a-link-routess"><i class="fa fa-sign-in" aria-hidden="true"></i> {{ $t('SellAutoInt.furtherpage') }}</router-link>
                </div>
            </div>
          </section>
  </template>
  
  <script>
  
  export default {
    name: 'SellAutoIntPage',
    computed: {
  
      localizedPath() {
        return (routeKey) => {
          return this.$localizedPath(routeKey);
        };
      }
      // ✅ Computed property to always get the current route name
  
    },
  };
  </script>
  
  <style scoped></style>
  